import React, { useState } from 'react';
import { Play, Clock, CheckCircle, BookOpen, Settings, TrendingUp, Globe, CreditCard, Video, Download, Search } from 'lucide-react';

const VideoTutorialsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [watchedVideos, setWatchedVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const categories = [
    { id: 'all', name: 'Todos os Vídeos', icon: <Video className="h-5 w-5" /> },
    { id: 'getting-started', name: 'Primeiros Passos', icon: <BookOpen className="h-5 w-5" /> },
    { id: 'api-setup', name: 'Configuração APIs', icon: <Settings className="h-5 w-5" /> },
    { id: 'content', name: 'Geração de Conteúdo', icon: <Globe className="h-5 w-5" /> },
    { id: 'tracking', name: 'Analytics', icon: <TrendingUp className="h-5 w-5" /> },
    { id: 'payments', name: 'Pagamentos', icon: <CreditCard className="h-5 w-5" /> }
  ];

  const tutorials = [
    {
      id: 1,
      title: "Configuração Inicial Completa (Setup em 15 Minutos)",
      description: "Passo a passo completo para configurar o sistema do zero até sua primeira comissão",
      duration: "15:32",
      category: "getting-started",
      difficulty: "Iniciante",
      thumbnail: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&h=225&fit=crop",
      videoUrl: "https://www.youtube.com/watch?v=DEMO_VIDEO_1",
      resources: [
        { name: "Checklist de Setup", type: "PDF", url: "#" },
        { name: "Templates de API", type: "JSON", url: "#" }
      ]
    },
    {
      id: 2,
      title: "ClickBank API - Configuração Detalhada",
      description: "Como obter e configurar suas chaves da ClickBank API para tracking real",
      duration: "8:45",
      category: "api-setup",
      difficulty: "Iniciante",
      thumbnail: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400&h=225&fit=crop",
      videoUrl: "https://www.youtube.com/watch?v=DEMO_VIDEO_2",
      resources: [
        { name: "Guia ClickBank", type: "PDF", url: "#" }
      ]
    },
    {
      id: 3,
      title: "Hotmart API - Integração Completa",
      description: "OAuth 2.0 setup e configuração avançada da Hotmart API",
      duration: "12:18",
      category: "api-setup",
      difficulty: "Intermediário",
      thumbnail: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=225&fit=crop",
      videoUrl: "https://www.youtube.com/watch?v=DEMO_VIDEO_3",
      resources: [
        { name: "Hotmart Developer Guide", type: "PDF", url: "#" }
      ]
    },
    {
      id: 4,
      title: "Amazon Associates - Setup Multi-Regional",
      description: "Configure Amazon Associates para 6 países simultaneamente",
      duration: "10:22",
      category: "api-setup",
      difficulty: "Intermediário",
      thumbnail: "https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?w=400&h=225&fit=crop",
      videoUrl: "https://www.youtube.com/watch?v=DEMO_VIDEO_4",
      resources: [
        { name: "Lista de Regiões Amazon", type: "Excel", url: "#" }
      ]
    },
    {
      id: 5,
      title: "IA de Conteúdo - Gerando Posts que Vendem",
      description: "Como usar a IA para criar conteúdo de alta conversão automaticamente",
      duration: "18:15",
      category: "content",
      difficulty: "Iniciante",
      thumbnail: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=225&fit=crop",
      videoUrl: "https://www.youtube.com/watch?v=DEMO_VIDEO_5",
      resources: [
        { name: "Templates de Prompts", type: "TXT", url: "#" },
        { name: "Exemplos de Posts", type: "PDF", url: "#" }
      ]
    },
    {
      id: 6,
      title: "Automação Social - Instagram + Facebook + TikTok",
      description: "Conecte suas redes sociais e configure postagem automática",
      duration: "14:30",
      category: "content",
      difficulty: "Intermediário",
      thumbnail: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=400&h=225&fit=crop",
      videoUrl: "https://www.youtube.com/watch?v=DEMO_VIDEO_6",
      resources: [
        { name: "Guia de Horários Ótimos", type: "PDF", url: "#" }
      ]
    },
    {
      id: 7,
      title: "Dashboard Real-Time - Interpretando Métricas",
      description: "Como ler e otimizar suas métricas de conversão e comissões",
      duration: "16:42",
      category: "tracking",
      difficulty: "Intermediário",
      thumbnail: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=225&fit=crop",
      videoUrl: "https://www.youtube.com/watch?v=DEMO_VIDEO_7",
      resources: [
        { name: "Guia de KPIs", type: "PDF", url: "#" }
      ]
    },
    {
      id: 8,
      title: "Sistema de Pagamentos - PIX, Stripe e PayPal",
      description: "Configure recebimento automático de comissões em múltiplas moedas",
      duration: "11:28",
      category: "payments",
      difficulty: "Avançado",
      thumbnail: "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=400&h=225&fit=crop",
      videoUrl: "https://www.youtube.com/watch?v=DEMO_VIDEO_8",
      resources: [
        { name: "Guia de Taxas", type: "PDF", url: "#" }
      ]
    },
    {
      id: 9,
      title: "Estratégias Avançadas - R$ 10k+ por Mês",
      description: "Técnicas dos top performers para escalar para R$ 10.000+ mensais",
      duration: "22:15",
      category: "getting-started",
      difficulty: "Avançado",
      thumbnail: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=400&h=225&fit=crop",
      videoUrl: "https://www.youtube.com/watch?v=DEMO_VIDEO_9",
      resources: [
        { name: "Planilha de Escalabilidade", type: "Excel", url: "#" },
        { name: "Case Studies", type: "PDF", url: "#" }
      ]
    },
    {
      id: 10,
      title: "Troubleshooting - Soluções para Problemas Comuns",
      description: "Como resolver os problemas mais frequentes do sistema",
      duration: "13:55",
      category: "getting-started",
      difficulty: "Intermediário",
      thumbnail: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=225&fit=crop",
      videoUrl: "https://www.youtube.com/watch?v=DEMO_VIDEO_10",
      resources: [
        { name: "FAQ Técnico", type: "PDF", url: "#" }
      ]
    }
  ];

  const filteredTutorials = tutorials.filter(tutorial => {
    const matchesCategory = selectedCategory === 'all' || tutorial.category === selectedCategory;
    const matchesSearch = tutorial.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         tutorial.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const toggleWatched = (videoId) => {
    if (watchedVideos.includes(videoId)) {
      setWatchedVideos(watchedVideos.filter(id => id !== videoId));
    } else {
      setWatchedVideos([...watchedVideos, videoId]);
    }
  };

  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case 'Iniciante': return 'text-green-400 bg-green-400/20 border-green-400/30';
      case 'Intermediário': return 'text-yellow-400 bg-yellow-400/20 border-yellow-400/30';
      case 'Avançado': return 'text-red-400 bg-red-400/20 border-red-400/30';
      default: return 'text-gray-400 bg-gray-400/20 border-gray-400/30';
    }
  };

  const totalDuration = tutorials.reduce((acc, tutorial) => {
    const [minutes, seconds] = tutorial.duration.split(':').map(Number);
    return acc + minutes + (seconds / 60);
  }, 0);

  const watchedCount = watchedVideos.length;
  const progressPercentage = (watchedCount / tutorials.length) * 100;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-white mb-4">
            🎥 Tutoriais em Vídeo
            <span className="bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent ml-4">
              MonetizeMaster
            </span>
          </h1>
          <p className="text-gray-300 text-lg mb-6">
            Aprenda a dominar o sistema com nossos tutoriais detalhados
          </p>
          
          {/* Progress Stats */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-lg p-4">
              <div className="text-2xl font-bold text-yellow-400">{tutorials.length}</div>
              <div className="text-gray-400 text-sm">Total de Vídeos</div>
            </div>
            <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-lg p-4">
              <div className="text-2xl font-bold text-green-400">{watchedCount}</div>
              <div className="text-gray-400 text-sm">Assistidos</div>
            </div>
            <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-lg p-4">
              <div className="text-2xl font-bold text-blue-400">{Math.round(totalDuration)}min</div>
              <div className="text-gray-400 text-sm">Duração Total</div>
            </div>
            <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-lg p-4">
              <div className="text-2xl font-bold text-purple-400">{Math.round(progressPercentage)}%</div>
              <div className="text-gray-400 text-sm">Progresso</div>
            </div>
          </div>
          
          {/* Progress Bar */}
          <div className="bg-gray-700 rounded-full h-2 mb-6">
            <div 
              className="bg-gradient-to-r from-yellow-400 to-orange-500 h-2 rounded-full transition-all duration-500"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
        </div>

        <div className="grid lg:grid-cols-4 gap-8">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="space-y-6">
              {/* Search */}
              <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-lg p-4">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Buscar tutoriais..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-yellow-500"
                  />
                </div>
              </div>
              
              {/* Categories */}
              <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-lg p-4 sticky top-8">
                <h3 className="text-lg font-bold text-white mb-4">Categorias</h3>
                <nav className="space-y-2">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setSelectedCategory(category.id)}
                      className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-all text-left ${
                        selectedCategory === category.id
                          ? 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30'
                          : 'text-gray-300 hover:bg-white/10 hover:text-white'
                      }`}
                    >
                      {category.icon}
                      <span className="font-medium">{category.name}</span>
                      <span className="ml-auto text-xs bg-white/10 px-2 py-1 rounded">
                        {category.id === 'all' ? tutorials.length : tutorials.filter(t => t.category === category.id).length}
                      </span>
                    </button>
                  ))}
                </nav>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-3">
            {selectedVideo ? (
              /* Video Player */
              <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-lg p-8 mb-8">
                <button
                  onClick={() => setSelectedVideo(null)}
                  className="text-gray-400 hover:text-white mb-4 flex items-center gap-2"
                >
                  ← Voltar aos vídeos
                </button>
                
                <h2 className="text-2xl font-bold text-white mb-4">{selectedVideo.title}</h2>
                
                {/* Video Player Placeholder */}
                <div className="aspect-video bg-black rounded-lg mb-6 flex items-center justify-center">
                  <div className="text-center text-gray-400">
                    <Play className="h-16 w-16 mx-auto mb-4" />
                    <p>Player de vídeo será carregado aqui</p>
                    <p className="text-sm mt-2">Integre com YouTube, Vimeo ou servidor próprio</p>
                    <p className="text-sm">URL: {selectedVideo.videoUrl}</p>
                  </div>
                </div>
                
                <div className="flex justify-between items-center mb-6">
                  <div className="flex items-center gap-4">
                    <span className={`px-3 py-1 rounded-full text-sm border ${getDifficultyColor(selectedVideo.difficulty)}`}>
                      {selectedVideo.difficulty}
                    </span>
                    <span className="flex items-center gap-1 text-gray-400">
                      <Clock className="h-4 w-4" />
                      {selectedVideo.duration}
                    </span>
                  </div>
                  <button
                    onClick={() => toggleWatched(selectedVideo.id)}
                    className={`px-4 py-2 rounded-lg font-medium transition-all ${
                      watchedVideos.includes(selectedVideo.id)
                        ? 'bg-green-600 text-white'
                        : 'bg-white/10 text-gray-300 hover:bg-white/20'
                    }`}
                  >
                    {watchedVideos.includes(selectedVideo.id) ? '✓ Assistido' : 'Marcar como Assistido'}
                  </button>
                </div>
                
                <p className="text-gray-300 mb-6">{selectedVideo.description}</p>
                
                {selectedVideo.resources && selectedVideo.resources.length > 0 && (
                  <div>
                    <h3 className="text-lg font-bold text-white mb-4">📁 Recursos Complementares</h3>
                    <div className="grid md:grid-cols-2 gap-4">
                      {selectedVideo.resources.map((resource, index) => (
                        <a
                          key={index}
                          href={resource.url}
                          className="bg-white/10 border border-white/20 rounded-lg p-4 hover:bg-white/20 transition-all flex items-center gap-3"
                        >
                          <Download className="h-5 w-5 text-yellow-400" />
                          <div>
                            <div className="text-white font-medium">{resource.name}</div>
                            <div className="text-gray-400 text-sm">{resource.type}</div>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              /* Video Grid */
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredTutorials.map((tutorial) => (
                  <div key={tutorial.id} className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-lg overflow-hidden hover:bg-white/10 transition-all group">
                    {/* Thumbnail */}
                    <div className="relative">
                      <img
                        src={tutorial.thumbnail}
                        alt={tutorial.title}
                        className="w-full h-48 object-cover"
                      />
                      <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                          onClick={() => setSelectedVideo(tutorial)}
                          className="bg-yellow-500 text-black p-3 rounded-full hover:bg-yellow-400 transition-colors"
                        >
                          <Play className="h-6 w-6" />
                        </button>
                      </div>
                      <div className="absolute top-3 right-3 bg-black/70 text-white px-2 py-1 rounded text-sm flex items-center gap-1">
                        <Clock className="h-3 w-3" />
                        {tutorial.duration}
                      </div>
                      {watchedVideos.includes(tutorial.id) && (
                        <div className="absolute top-3 left-3 bg-green-500 text-white p-1 rounded-full">
                          <CheckCircle className="h-4 w-4" />
                        </div>
                      )}
                    </div>
                    
                    {/* Content */}
                    <div className="p-4">
                      <div className="flex items-center justify-between mb-2">
                        <span className={`px-2 py-1 rounded-full text-xs border ${getDifficultyColor(tutorial.difficulty)}`}>
                          {tutorial.difficulty}
                        </span>
                        <button
                          onClick={() => toggleWatched(tutorial.id)}
                          className={`text-xs px-2 py-1 rounded transition-all ${
                            watchedVideos.includes(tutorial.id)
                              ? 'bg-green-600 text-white'
                              : 'bg-white/10 text-gray-400 hover:bg-white/20'
                          }`}
                        >
                          {watchedVideos.includes(tutorial.id) ? '✓' : '○'}
                        </button>
                      </div>
                      
                      <h3 className="text-white font-bold mb-2 line-clamp-2 group-hover:text-yellow-400 transition-colors">
                        {tutorial.title}
                      </h3>
                      
                      <p className="text-gray-400 text-sm mb-4 line-clamp-3">
                        {tutorial.description}
                      </p>
                      
                      <button
                        onClick={() => setSelectedVideo(tutorial)}
                        className="w-full bg-gradient-to-r from-yellow-500 to-orange-600 text-white py-2 rounded-lg font-medium hover:from-yellow-600 hover:to-orange-700 transition-all flex items-center justify-center gap-2"
                      >
                        <Play className="h-4 w-4" />
                        Assistir Agora
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            
            {filteredTutorials.length === 0 && (
              <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-lg p-12 text-center">
                <Video className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                <h3 className="text-xl font-bold text-white mb-2">Nenhum vídeo encontrado</h3>
                <p className="text-gray-400">Tente buscar com outros termos ou selecione uma categoria diferente.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoTutorialsPage;